type InfoOutlineIconProps = {
  size?: number;
  color?: string;
};

const InfoOutlineIcon = ({
  size = 18,
  color = '#131313',
}: InfoOutlineIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M16.7146 9C16.7146 4.73957 13.2605 1.28549 9 1.2854C4.73952 1.2854 1.2854 4.73952 1.2854 9C1.28549 13.2605 4.73957 16.7146 9 16.7146C13.2604 16.7145 16.7145 13.2604 16.7146 9ZM18 9C17.9999 13.9705 13.9705 17.9999 9 18C4.02949 18 8.52343e-05 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 8.52367e-05 18 4.02949 18 9Z"
      fill={color}
    />
    <path
      d="M10.9277 12.214C11.2827 12.214 11.5704 12.5017 11.5704 12.8567C11.5704 13.2116 11.2827 13.4993 10.9277 13.4994H7.07042C6.71538 13.4994 6.42772 13.2117 6.42772 12.8567C6.42772 12.5016 6.71538 12.214 7.07042 12.214H10.9277Z"
      fill={color}
    />
    <path
      d="M8.35765 12.8567V8.99936H7.71495C7.35991 8.99936 7.07225 8.7117 7.07225 8.35666C7.07225 8.00162 7.35991 7.71396 7.71495 7.71396H9.00035C9.35539 7.71396 9.64305 8.00162 9.64305 8.35666V12.8567C9.64305 13.2117 9.35539 13.4994 9.00035 13.4994C8.64546 13.4992 8.35765 13.2116 8.35765 12.8567Z"
      fill={color}
    />
    <path
      d="M9.00072 4.17929C9.35554 4.17954 9.64342 4.4671 9.64342 4.82199C9.64342 4.93956 9.60845 5.04797 9.55333 5.14279C9.60877 5.23778 9.64339 5.34678 9.64342 5.46469C9.64342 5.81957 9.35554 6.10713 9.00072 6.10739C8.50132 6.10739 8.08972 5.72809 8.04052 5.24166L8.03612 5.14388L8.04052 5.04501C8.08979 4.55865 8.50137 4.17929 9.00072 4.17929Z"
      fill={color}
    />
    <path
      d="M9.9657 5.14397C9.96544 5.67631 9.53312 6.10739 9.00072 6.10739C8.64568 6.10739 8.3584 5.81981 8.3584 5.46477C8.35843 5.34678 8.39298 5.23791 8.44849 5.14287C8.3933 5.04801 8.3584 4.93973 8.3584 4.82207C8.3584 4.46703 8.64568 4.17929 9.00072 4.17929C9.53328 4.17929 9.9657 4.61141 9.9657 5.14397Z"
      fill={color}
    />
  </svg>
);

export default InfoOutlineIcon;
